import Xendit from "./xendit";
import Redirect from "./redirect";
import MolPay from "./molpay";
import PayGate from "./paygate";

const ComponentMapper = {
  xendit: Xendit,
  molpay: MolPay,
  paygate: PayGate,
};

export const getComponentForEnumValue = (enumValue) => {
  return ComponentMapper[enumValue.toLowerCase()] || Redirect;
};
